import React, {useState} from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart, Subtitle, CointainerFigureImage } from '../../components/AppComponents';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more'; 
import highchartsGroupedCategories from 'highcharts-grouped-categories';
import { figure65 } from '../../graphs/fr/figure65';
import { figure69 } from '../../graphs/fr/figure69';
import { figure70 } from '../../graphs/fr/figure70';
import { figure71 } from '../../graphs/fr/figure71';
import { figure74 } from '../../graphs/fr/figure74';
import Modal from "../../components/Modal";

// import { figure55 } from '../graphs/en/figure55';
// eslint-disable-next-line
highchartsMore(Highcharts);
highchartsGroupedCategories(Highcharts);

const Sdg15 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="15"
                poster={require('../../images/poster-sdg-15.png').default}
                video={require('../../images/video-sdg-15.mp4').default}
                sdgImage={require('../../images/EN_15.svg').default}
                sdg="OBJECTIF DE DÉVELOPPEMENT DURABLE 15"
                title="Vie terrestre"
                subtitle="Préserver et restaurer les écosystèmes terrestres, en veillant à les exploiter de façon durable, gérer durablement les forêts, lutter contre la désertification, enrayer et inverser le processus de dégradation des sols et mettre fin à l’appauvrissement de la biodiversité."
                summaryTable={require('../../images/Goal_15.zip').default}
                indicators={['15.1.1', '15.2.1', '15.4.2', '15.6.1']}  
                indicatorsTitle="INDICATEURS"
                summaryTableTitle= "TABLEAUX RÉCAPITULATIFS"
            />

            <Container>
                <TitleSub title="Vue d’ensemble" />
                <p>La déforestation, la dégradation des terres et des écosystèmes et l’appauvrissement de la biodiversité progressent dans le monde entier et constituent des menaces majeures pour le bien-être humain et le développement durable. Même si des efforts sont faits en matière de gestion durable des forêts et des ressources naturelles, il est urgent de prendre des engagements et de mettre en oeuvre des instruments conçus pour préserver, restaurer et exploiter de façon durable les forêts et la biodiversité afin d’assurer la bonne santé et la résilience des sociétés.</p>
                <p>La surface totale des forêts de la planète a reculé de 100 millions d’hectares depuis 2000, bien que la vitesse de déforestation se soit ralentie ces dernières années. Le couvert végétal des zones de montagne est resté relativement stable autour de 73 pour cent entre 2000 et 2020. Des signes encourageants montrent que l’adoption de pratiques de gestion durable des forêts a progressé au cours de la dernière décennie. En parallèle, un nombre croissant de pays prennent des mesures pour faciliter l’échange de matériel phytogénétique afin de favoriser l’accès et le partage des avantages.</p>
                <div id="section15.1.1">
                    <HeaderSdg 
                        title="INDICATEUR 15.1.1"
                        subtitle="Surface des zones forestières, en proportion de la surface terrestre"
                        badges={[
                            {color: '#cecece', text: 'Évaluation de l’état d’avancement: impossible en l’absence de critère numérique dans la cible.'},
                            { color: '#ff0100', text: 'Évaluation de la tendance: détérioration depuis l’année de référence.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.1',
                            text: 'D’ici à 2020, garantir la préservation, la restauration et l’exploitation durable des écosystèmes terrestres et des écosystèmes d’eau douce et des services connexes, en particulier des forêts, des zones humides, des montagnes et des zones arides, conformément aux obligations découlant des accords internationaux.'
                        }}
                    />
                </div>

                <p><i>En 2020, les forêts couvraient 31,2 pour cent des terres émergées du globe, soit 100 millions d’hectares de moins en l’espace de 20 ans.</i></p>
                <p>La proportion des terres émergées de la planète qui sont couvertes de forêts a diminué, passant de 31,9 pour cent en 2000 (4,2 milliards d’hectares) à 31,5 pour cent en 2010, puis à 31,2 pour cent (4,1 milliards d’hectares) en 2020. Ces chiffres représentent un recul de près de 100 millions d’hectares de la surface forestière au cours des 20 dernières années. Le rythme de déforestation s’est ralenti légèrement durant la dernière décennie.</p>
                <p>La tendance mondiale au recul de la forêt résulte de dynamiques régionales différentes. L’Asie, l’Europe et l’Amérique du Nord ont en réalité enregistré une augmentation globale de leur superficie de forêt entre 2000 et 2020 grâce à des activités de boisement et de restauration de paysages ainsi qu’à l’expansion naturelle des forêts. L’augmentation a toutefois été moins rapide entre 2010 et 2020 qu’entre 2000 et 2010.</p>
                <p>En revanche, l’Amérique latine, les Caraïbes et l’Afrique subsaharienne ont perdu d’importantes superficies forestières ces 20 dernières années, principalement du fait de la conversion de forêts en terres agricoles destinées à être cultivées ou à servir de pâturages. Les PMA sont particulièrement touchés par les pertes de surfaces forestières. Les forêts jouent un rôle important dans les conditions d’existence et le bien-être des populations rurales et urbaines. Elles contribuent notamment à réguler le cycle de l’eau et à atténuer le changement climatique, et abritent la majeure partie de la biodiversité terrestre du globe. Leur disparition participe au réchauffement de la planète et porte atteinte à la faune et la flore sauvages; elle menace les moyens d’existence des pauvres et a des effets sur l’utilisation des terres, par exemple l’agriculture, et sur les services environnementaux. </p>
                <p>Bien que les répercussions de la pandémie de covid-19 sur les forêts ne soient pas encore mesurées, il est probable qu’elle ait eu des effets négatifs sur les ressources forestières et accru le risque de déforestation et de recul de la biodiversité associée. Les forêts jouent un rôle clé en procurant des moyens d’existence aux plus vulnérables et en augmentant leur résilience contre des crises comme celles de la covid-19. Faute de programmes sociaux appropriés pour aider ces populations, la pression sur le couvert forestier et l’intégrité de l’environnement risque d’augmenter. </p>
                <p>Il est essentiel de maintenir la dynamique d’arrêt de la déforestation et de la dégradation des forêts et de restaurer les écosystèmes endommagés si l’on veut améliorer la résilience des écosystèmes face au climat, éviter l’appauvrissement de la biodiversité et améliorer les moyens d’existence des populations rurales, en particulier dans les régions tropicales et les PMA. </p>
            </Container>

            <ContainerChart 
                title="Figure 65. Surface des zones forestières, en proportion de la surface terrestre (%) (2000, 2010 et 2020)"
                legend={[
                    {title: '2000', color: '#71ad47'},
                    {title: '2010', color: '#90D052'},
                    {title: '2020', color: '#395824'},
                ]} note={<span>Note: La présente mise à jour annuelle de l’indicateur 15.1.1 utilise les dernières données de l’Évaluation des ressources forestières mondiales 2020, qui se fonde sur les meilleures données et informations nationales à ce jour (FAO, 2022).
                    <br />Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 24 juin 2022. www.fao.org/sustainable-development-goals/indicators/fr.</span>}>

                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure65}
                />
            </ContainerChart>

            <CointainerFigureImage
                title="Figure 66. Répartition mondiale de la surface des zones forestières en pourcentage de la surface terrestre (2020)"
                image={require('../../images/figuremap66.png').default}
                legendCSSclassName="half-width-entries"
                legend={[
                    { title: ['1', <sup>er&#160;</sup>, 'quintile'], color: '#ff0000', customCSSClass: 'half-width' },
                    { title: ['2', <sup>e&#160;</sup>, 'quintile'], color: '#ffa503', customCSSClass: 'half-width' },
                    { title: ['3', <sup>e&#160;</sup>, 'quintile'], color: '#FFFF00', customCSSClass: 'half-width' },
                    { title: ['4', <sup>e&#160;</sup>, 'quintile'], color: '#32CD32', customCSSClass: 'half-width' },
		    { title: ['5', <sup>e&#160;</sup>, 'quintile'], color: '#006400', customCSSClass: 'half-width' },
                ]}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l'Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre la République du Soudan et la République du Soudan du Sud n’a pas encore été défini. <br /><br />
Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 7 juillet 2022. www.fao.org/sustainable-development-goals/indicators/fr (modifié conformément aux indications de la Section de l’information géospatiale de l’Organisation des Nations Unies, 2022).</span>}>

            </CointainerFigureImage>

            <CointainerFigureImage
                title="Figure 67. Surface des zones forestières en pourcentage de la surface terrestre (2015-2020)"
                image={require('../../images/figuremap67.png').default}
                legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Amélioration', color: '#006400', customCSSClass: 'half-width'},
                    {title: 'Pas ou peu d’amélioration', color: '#28cb28', customCSSClass: 'half-width'},
                    {title: 'Légère détérioration', color: '#ffa400', customCSSClass: 'half-width'},
                    {title: 'Détérioration', color: '#ff0000', customCSSClass: 'half-width'},
                    {title: 'Données insuffisantes', color: '#808080', customCSSClass: 'half-width mr-auto'}
                ]}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l'Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre la République du Soudan et la République du Soudan du Sud n’a pas encore été défini. <br /><br />
Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 7 juillet 2022. www.fao.org/sustainable-development-goals/indicators/fr (modifié conformément aux indications de la Section de l’information géospatiale de l’Organisation des Nations Unies, 2022).</span>}>

            </CointainerFigureImage>


            <Container>
                <div id="section15.2.1">
                    <HeaderSdg 
                        title="INDICATEUR 15.2.1"
                        subtitle="Progrès vers la gestion durable des forêts"
                        badges={[
                            {color: '#cecece', text: 'Évaluation de l’état d’avancement: impossible en l’absence de critère numérique dans la cible.'},
                            {color: '#cecece', text: 'Évaluation de la tendance: non réalisée pour des raisons méthodologiques.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.2',
                            text: 'D’ici à 2020, promouvoir la gestion durable de tous les types de forêt, mettre un terme à la déforestation, restaurer les forêts dégradées et accroître considérablement le boisement et le reboisement au niveau mondial.'
                        }}
                    />
                </div>
                
                <p><i>Malgré des progrès en matière de gestion durable des forêts au niveau mondial, les pertes forestières restent importantes.</i></p>
                <p>Au cours des dix dernières années, des progrès ont été faits en matière de gestion durable des forêts dans le monde. La superficie totale des zones forestières soumises à un système de certification a progressé de 35 pour cent (soit 120 millions d’hectares) depuis 2010. Entre 2020 et 2021, la superficie de forêt certifiée a augmenté de 27 millions d’hectares. Cette évolution positive est observée principalement en Europe et en Amérique du Nord, où 22 millions d’hectares ont été certifiés l’an dernier, et 87 millions d’hectares depuis 2010. </p>
                <p>À l’échelon mondial, la proportion de zones forestières incluses dans des aires protégées a augmenté pour passer de 17 pour cent en 2010 à 18 pour cent en 2020. C’est en Asie centrale que l’on trouve la plus grande proportion de forêts dans des aires protégées (59 pour cent), et aussi que l’augmentation a été la plus forte pendant la période (12 pour cent). L’Europe et l’Amérique du Nord avaient la plus faible proportion de forêts se trouvant dans des aires protégées en 2020 (6 pour cent). </p>
                <p>La superficie des forêts faisant l’objet d’un plan de gestion a progressé de 7 pour cent entre 2010 et 2020. La plupart des forêts d’Europe et d’Asie sont soumises à un plan de gestion, les augmentations les plus importantes ayant été enregistrées en Asie centrale et en Asie de l’Est. En revanche, en Amérique latine et Caraïbes, en Océanie et en Afrique subsaharienne, la proportion de forêts soumises à un plan de gestion reste inférieure à un tiers (bien qu’elle progresse lentement). La quantité totale de biomasse aérienne dans les forêts a légèrement augmenté grâce à une hausse notable en Asie de l’Est, en Europe et en Asie de l’Ouest.</p>
                <p>Le taux de variation annuel de la superficie forestière reste relativement stable au niveau mondial autour de - 0,1 pour cent, ce qui indique que le recul des forêts se poursuit, à un rythme néanmoins un peu plus lent que durant la décennie passée. La surface de forêts s’est étendue en Asie, en Europe et en Amérique du Nord entre 2010 et 2020, tandis que d’importantes superficies forestières ont disparu en Afrique, en Asie du Sud-Est et en Amérique latine et Caraïbes. Ce recul est principalement imputable à l’expansion de l’agriculture (cultures et élevage). La déforestation et la dégradation des forêts demeurent des enjeux majeurs, en particulier dans les pays tropicaux, les PMA, les PDSL et les PEID, d’où la nécessité de prendre davantage de mesures pour réduire le déboisement et adopter des pratiques de gestion durable des forêts et des sols.</p>
                <p>Les forêts sont les plus grands réservoirs de carbone et de biodiversité de la planète. Elles représentent une source essentielle d’aliments, de biens et de services et sont vitales pour la subsistance des populations les plus pauvres et des communautés rurales. Il importe d’accélérer les mesures prises aux niveaux mondial et régional pour préserver les écosystèmes forestiers et maintenir leurs fonctions sociales, économiques et écologiques, en mettant particulièrement l’accent sur les régions tropicales et les pays en développement.</p>

            </Container>

            <div className="chart-container">
                <div className="chart-title"><h2>Figure 68. Tableau de bord des sous-indicateurs 15.2.1 des ODD</h2></div>
                <table className="table desktop-table">
                    <thead className="subcategory_thead enter" >
                        <tr>
                            
                            <th className="border-0">
                               
                            </th>
                            <th className="pb-0 w-custom">
                                <div><span><small>Progrès entre les périodes 2000-2010 et 2010-2020</small></span></div>
                            </th>
                            <th className="" colSpan="3">
                                <div><span><small>Progrès entre 2010 et 2020</small></span></div>
                            </th>
                            <th className="">
                                <div><span><small>Progrès entre 2020 et 2021</small></span></div>
                            </th>
                            
                        </tr>
                    </thead>
                    <thead className="subcategory_thead table-prevalence-title enter">
                        <tr>
                            <th>Région ODD</th>
                            <th className="rotate">
                                <div><span>Variation annuelle de la<br/> superficie forestière<sup>*</sup></span></div>
                            </th>
                            <th className="rotate pb-0">
                                <div><span>Stock de biomasse aérienne<br/> dans les forêts (tonnes/ha)</span></div>
                            </th>
                            <th className="rotate pb-0">
                                <div><span>Proportion de la superficie<br/> forestière se trouvant dans<br/> des aires protégées</span></div>
                            </th>
                            <th className="rotate pb-0">
                                <div><span>Proportion de la superficie<br/> forestière faisant l’objet d’un <br/>plan de gestion à long terme</span></div>
                            </th>
                            <th className="rotate">
                                <div><span>Superficie de forêt certifiée</span></div>
                            </th>
                        </tr>
                    </thead>
                    <thead className="othcategory_thead enter">
                        <tr>
                            <th scope="row" className="teal">Monde</th>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                    </thead>
                    <tbody className="enter">
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Asie centrale et du Sud</th>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="gray"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Asie centrale</i></li></ul></th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Asie du Sud</i></li></ul></th>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="yellow"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Asie de l’Est et du Sud-Est</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="red"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Asie de l’Est</i></li></ul></th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="red"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Asie du Sud-Est</i></li></ul></th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Afrique du Nord et Asie de l’Ouest</th>
                            <td className="red"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Afrique du Nord</i></li></ul></th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td ></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Asie de l’Ouest</i></li></ul></th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Afrique subsaharienne</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Europe et Amérique du Nord</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Europe</i></li></ul></th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Amérique du Nord</i></li></ul></th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Amérique latine et Caraïbes Océanie</th>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="font-weight-normal grey">Oceania</th>
                            <td className="green"></td>
                            <td className="red"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Océanie (hors Australie et Nouvelle-Zélande)</i></li></ul></th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="yellow"></td>
                        </tr>
                        <tr>
                            <th scope="row"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><i>Australie et Nouvelle-Zélande</i></li></ul></th>
                            <td className="green"></td>
                            <td className="red"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="teal">Pays en développement sans littoral</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="teal">Pays les moins avancés</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="teal">Petits États insulaires en développement</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="red"></td>
                        </tr>
                    </tbody>
                </table>


                <table className="table mobile-table">
                    <tbody>
                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">World</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Central and Southern Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data yellow"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Central Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Southern Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data yellow"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Eastern and South-Eastern Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data red"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Eastern Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data red"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">South-Eastern Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Northern Africa and Western Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Northern Africa</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Western Asia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Sub-Saharan Africa</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Europe and Northern America</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Europe</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Northern America</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Latin America and the Caribbean</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Oceania</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Oceania (exc. Australia and New Zealand)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data yellow"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Australia and New Zealand</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Landlocked developing countries (LLDCs)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Least Developed Countries (LDCs)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Small island developing States (SIDS)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Annual rate of change in forest  area*</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Above-ground biomass stock in forests (tonnes/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area within legally established protected areas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Proportion of forest area under a long-term forest management plan</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Certified forest area</td>
                            <td className="data red"></td>
                        </tr>
                    </tbody>
                </table>

                <ul className="list-unstyled list-inline text-center legend legend-table mt-4 half-width-entries">
                    <li className="list-inline-item"><span className="point position-static"></span>Variation positive</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variation faible ou nulle</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variation négative</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Pas de forêt certifiée</li>
                </ul>

                <p className="note text-center">Note: <sup>*</sup> Le taux de variation annuel de la superficie forestière est obtenu au moyen d’une formule de taux de croissance composé.
                    <br />Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 24 juin 2022. www.fao.org/sustainable-development-goals/indicators/fr.</p>
            </div>

            <ContainerChart 
                title="Figure 69. Superficie de forêt certifiée (en milliers d’hectares) (2000-2020)"
                                legendCSSClass="half-width-entries"

                legend={[
                    { title: 'Monde', color: '#ed7d30', customCSSClass: 'half-width'},
                    { title: 'Asie centrale et du Sud', color: '#a4a4a5', customCSSClass: 'half-width' },
                    { title: 'Asie de l’Est et du Sud-Est', color: '#71ad47', customCSSClass: 'half-width'},
                    { title: 'Afrique du Nord et Asie de l’Ouest', color: '#636363', customCSSClass: 'half-width' },
                    { title: 'Afrique subsaharienne', color: '#43682b', customCSSClass: 'half-width' },
                    { title: 'Europe et Amérique du Nord', color: '#7baedd', customCSSClass: 'half-width' },
                    { title: 'Amérique latine et Caraïbes', color: '#ffcd32', customCSSClass: 'half-width' },
                    { title: 'Océanie', color: '#6b8ed0', customCSSClass: 'half-width' },
                ]}
                note={<span>Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 24 juin 2022. www.fao.org/sustainable-development-goals/indicators/fr.</span>}>

                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure69}
                />
            </ContainerChart>




            <Container>
                <div id="section15.4.2">
                    <HeaderSdg 
                        title="INDICATEUR 15.4.2"
                        subtitle="Indice de couvert végétal montagneux"
                        badges={[
                            {color: '#cecece', text: 'Évaluation de l’état d’avancement: impossible en l’absence de critère numérique dans la cible.'},
                            { color: '#c4e0b3', text: 'Évaluation de la tendance: pas ou peu d’amélioration depuis l’année de référence.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.4',
                            text: 'D’ici à 2030, assurer la préservation des écosystèmes montagneux, notamment de leur biodiversité, afin de mieux tirer parti de leurs bienfaits essentiels pour le développement durable.'
                        }}
                    />
                </div>
                <p><i>Le couvert végétal des zones montagneuses dans le monde est resté stable autour des trois quarts de la superficie de ces zones pendant la période comprise entre 2000 et 2020.</i></p>
                <p>Bien qu’elles ne constituent qu’environ un quart des terres émergées du globe, les régions de montagne contribuent proportionnellement davantage à la biodiversité mondiale puisqu’elles abritent plus de 85 pour cent des espèces d’amphibiens, d’oiseaux et de mammifères de la planète <span className="ref" onClick={() => handleClickOpen('<b>Rahbek, C., Borregaard, M.K., Colwell, R.K., Dalsgaard, B., Holt, B.G., Morueta-Holme, N., Nogues-Bravo, D., Whittaker, R.J. & Fjeldså, J.</b> 2019. Humboldt’s enigma: what causes global patterns of mountain biodiversity? <i>Science</i>, 365 (6458): 1108–1113.')}>(Rahbek <i>et al.</i>, 2019)</span>. Elles procurent en outre des ressources vitales, par exemple de l’eau propre, à une part importante de la population mondiale. Les montagnes sont pourtant menacées par de multiples facteurs de changement, dont le changement climatique, la conversion des terres, la pollution, l’introduction d’espèces et la surexploitation des ressources naturelles. L’interaction de ces facteurs peut affecter de façon irréversible les écosystèmes de montagne et leur biodiversité.</p>
                <p>Une analyse du couvert végétal des montagnes et de son évolution dans le temps peut fournir des informations sur l’état des écosystèmes montagnards et sur leur capacité à favoriser un développement durable. L’indicateur 15.4.2 des ODD – l’indice de couvert végétal montagneux – est resté relativement stable autour de 73 pour cent entre 2000 et 2020, avec une légère diminution (0,09 point de pourcentage) depuis 2015. Le rôle des facteurs bioclimatiques dans le niveau du couvert végétal montagneux est évident à l’échelon régional (figure 71). Les régions tropicales et subtropicales caractérisées par des chaînes de montagne de basse ou moyenne altitude présentent habituellement les valeurs de couvert végétal les plus hautes (Océanie). À l’inverse, ces valeurs sont en général plus basses dans les régions de haute montagne des zones tempérées et boréales, où l’environnement montagnard est moins favorable à la croissance de la végétation (Amérique du Nord et Europe). Les régions constituées pour une part importante de zones arides, comme l’Afrique du Nord, ont aussi tendance à avoir des valeurs moindres de couvert végétal montagneux. </p>
                <Subtitle text="Interprétation du couvert végétal des zones montagneuses" />
                <p>Les chiffres du couvert végétal montagneux doivent être interprétés avec prudence. En eux-mêmes, ils ne donnent pas d’indications sur l’évolution précise des espèces, ni sur la limite des arbres ou la conversion d’écosystèmes naturels à l’agriculture. De plus, tous les changements du couvert végétal ne peuvent pas être considérés comme positifs car, par exemple, une augmentation du couvert végétal peut résulter d’un recul des glaciers ou d’une disparition du couvert neigeux. Les variations observées dans la composition des espèces et la limite des arbres sont utiles pour repérer les effets à long terme du changement climatique dans les régions de montagne. Il est donc important d’examiner ces variations dans chaque zone d’altitude au fil du temps pour déterminer les mesures de gestion et d’adaptation appropriées.</p>
                </Container>

            <ContainerChart 
                title="Figure 70. Couvert montagneux mondial, par catégorie de montagne et par type de couvert terrestre (%) (2020)"
                legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Forêt', color: '#385723'},
                    {title: 'Prairie', color: '#92d04e'},
                    {title: 'Terre cultivée', color: '#FFCC09'},
                    { title: 'Zone humide', color: '#204e79' },
                    { title: 'Zone peuplée', color: '#ff0000' },
                    { title: 'Autre', color: '#a5a6a5' },
                ]} note={<span>Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 24 juin 2022. www.fao.org/sustainable-development-goals/indicators/fr.</span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure70}
                />

                <table className="annex-table text-center">
                    <thead>
		       <tr>
			  <th colspan="6">Classification des montagnes du monde par le Centre mondial de surveillance de la conservation du Programme des Nations Unies pour l’environnement</th>
		       </tr>
                        <tr>
                            <th scope="col">Catégorie 1</th>
                            <th scope="col">Catégorie 2 </th>
                            <th scope="col">Catégorie 3 </th>
                            <th scope="col">Catégorie 4 </th>
                            <th scope="col">Catégorie 5 </th>
                            <th scope="col">Catégorie 6 </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>&gt; 4 500 m</td>
                            <td>3 500-4 500 m</td>
                            <td>2 500-3 500 m</td>
                            <td>1 500-2 500 m</td>
                            <td>1 000-1 500 m et pente &gt; 5<sup>o</sup> ou LER &gt; 300 m</td>
                            <td>300-1 000 m et LER &gt; 300 m</td>
                        </tr>
                    </tbody>
                </table>
            </ContainerChart>

            

            <ContainerChart 
                title="Figure 71. Indice de couvert végétal montagneux par région (%) (2020)"
                legend={[
                   
                ]} note={<span>Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 24 juin 2022. www.fao.org/sustainable-development-goals/indicators/fr.</span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure71}
                />
            </ContainerChart>

            <CointainerFigureImage
                title="Figure 72. Répartition mondiale de l’indice de couvert végétal montagneux (2018)"
                image={require('../../images/figuremap72.png').default}
                legendCSSClass="half-width-entries"
                legend={[
                    { title: ['1', <sup>er&#160;</sup>, 'quintile'], color: '#ff0000', customCSSClass: 'half-width' },
                    { title: ['2', <sup>e&#160;</sup>, 'quintile'], color: '#ffa503', customCSSClass: 'half-width' },
                    { title: ['3', <sup>e&#160;</sup>, 'quintile'], color: '#FFFF00', customCSSClass: 'half-width' },
                    { title: ['4', <sup>e&#160;</sup>, 'quintile'], color: '#32CD32', customCSSClass: 'half-width' },
		    { title: ['5', <sup>e&#160;</sup>, 'quintile'], color: '#006400', customCSSClass: 'half-width' },
                    { title: 'Données insuffisantes', color: '#808080', customCSSClass: 'half-width' }
                ]}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l'Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre la République du Soudan et la République du Soudan du Sud n’a pas encore été défini. <br /><br />
Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 7 juillet 2022. <a href="http://www.fao.org/sustainable-development-goals/indicators/fr">www.fao.org/sustainable-development-goals/indicators/fr</a> (modifié conformément aux indications de la Section de l’information géospatiale de l’Organisation des Nations Unies, 2022).</span>}>

            </CointainerFigureImage>

            <CointainerFigureImage
                title="Figure 73. Progrès dans l’amélioration de l’indice de couvert végétal montagneux, par région (2015-2018)"
                image={require('../../images/figuremap73.png').default}
                legendCSSClass="half-width-entries"

                legend={[
                    {title: 'Amélioration', color: '#006400', customCSSClass: 'half-width'},
                    {title: 'Pas ou peu d’amélioration', color: '#28cb28', customCSSClass: 'half-width'},
                    {title: 'Légère détérioration', color: '#ffa400', customCSSClass: 'half-width'},
                    {title: 'Détérioration', color: '#ff0000', customCSSClass: 'half-width'},
                    {title: 'Données insuffisantes', color: '#808080', customCSSClass: 'half-width mr-auto'}
                ]}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l'Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre la République du Soudan et la République du Soudan du Sud n’a pas encore été défini. <br /><br />
 Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 7 juillet 2022. www.fao.org/sustainable-development-goals/indicators/fr (modifié conformément aux indications de la Section de l’information géospatiale de l’Organisation des Nations Unies, 2022).</span>}>

            </CointainerFigureImage>


            <Container>
                <div id="section15.6.1">
                    <HeaderSdg
                        title="INDICATEUR 15.6.1"
                        subtitle="Nombre de pays ayant adopté des cadres législatifs, administratifs et opérationnels destinés à assurer un partage juste et équitable des bénéfices"
                        // badges={[
                        //     {color: '#ffbf02', text: 'Status assessment: Not possible due to absence of numerical yardstick in target'},
                        //     {color: '#ff0100', text: 'Trend assessment: Slight or no improvement'},
                        // ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.6',
                            text: 'Favoriser le partage juste et équitable des bénéfices découlant de l’utilisation des ressources génétiques et promouvoir un accès approprié à celles-ci, ainsi que cela a été décidé à l’échelle internationale.'
                        }}
                    />
                </div>

                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Séries de données</th>
                        <th scope="col">Évaluation de la tendance</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Pays qui sont parties au Traité international sur les ressources phytogénétiques pour l’alimentation et l’agriculture</td>
                            <td>Amélioration</td>
                        </tr>
                        <tr>
                            <td>Pays qui disposent de mesures ou de cadres législatifs, administratifs et opérationnels communiqués par le biais du Système d’établissement de rapports en ligne sur l’application du Traité international sur les ressources phytogénétiques pour l’alimentation et l’agriculture</td>
                            <td>Amélioration</td>
                        </tr>
                        <tr>
                            <td>Nombre total déclaré d’accords types de transfert de matériel transférant au pays des ressources phytogénétiques destinées à l’alimentation et à l’agriculture</td>
                            <td>Amélioration</td>
                        </tr>
                    </tbody>
                </table>

                <p><i>De plus en plus de pays prennent des mesures pour assurer l’accès aux ressources phytogénétiques pour l’alimentation et l’agriculture et le partage des bénéfices en découlant, mais il faut faire davantage.</i></p>
                <p>Fin 2021, 68 pays avaient au moins une mesure législative, administrative ou opérationnelle en place pour assurer le partage juste et équitable des avantages découlant de l’utilisation des ressources génétiques et des savoirs traditionnels associés, conformément au Protocole de Nagoya.</p>
                <p>Par ailleurs, 79 pays ont déclaré avoir des mesures en place pour mettre en oeuvre le Traité international sur les ressources phytogénétiques pour l’alimentation et l’agriculture.</p>
                <p>Le Protocole de Nagoya sur l’accès aux ressources génétiques et le partage juste et équitable des avantages découlant de leur utilisation est entré en vigueur le 12 octobre 2014 en tant qu’accord complémentaire à la Convention sur la diversité biologique. De nombreux pays, parties ou non au Protocole de Nagoya, ont énormément avancé dans la mise en place de cadres d’accès et de partage des avantages.</p>
		<p>Au 10 juin 2022, 137 pays et l’Union européenne avaient ratifié le Protocole. Le secrétariat de la Convention sur la diversité biologique se mobilise auprès des pays pour faciliter le processus de publication de certificats de conformité reconnus au niveau international.</p>

                <Subtitle text="Faciliter l’accès aux ressources végétales" />
                <p>Le Traité sur les ressources phytogénétiques pour l’alimentation et l’agriculture aide les agriculteurs et les sélectionneurs à accéder à du matériel phytogénétique pour mettre au point de nouvelles variétés végétales permettant d’adapter la production agricole aux évolutions de l’environnement, dans le but d’améliorer la sécurité alimentaire mondiale. L’échange de matériel végétal permet de partager les bénéfices monétaires et non monétaires découlant de l’utilisation de ce matériel avec les agriculteurs de pays en développement, et les incite fortement à continuer de le conserver et de l’utiliser de manière durable.</p>
                <p>En février 2021, on comptait 148 parties au Traité. À ce jour, plus de 85 000 contrats – appelés accords types de transfert de matériel, utilisés pour faciliter l’échange de matériel phytogénétique (voir la figure 74 ci-dessous) – ont été conclus.</p>
            </Container>

            <ContainerChart 
                title="Figure 74. Nombre d’accords types de transfert de matériel conclus pour transférer des ressources phytogénétiques destinées à l’alimentation et à l’agriculture dans le monde (2012-2022)"
                legendCSSClass="half-width-entries"

                legend={[
                    { title: 'Australie et Nouvelle-Zélande', color: '#5b9bd6', customCSSClass: 'half-width' },
                    { title: 'Asie centrale et du Sud', color: '#ed7e31', customCSSClass: 'half-width' },
                    { title: 'Asie de l’Est et du Sud-Est', color: '#a6a5a4', customCSSClass: 'half-width' },
                    { title: 'Amérique latine et Caraïbes', color: '#ffbf00', customCSSClass: 'half-width' },
                    { title: 'Afrique du Nord', color: '#4372c4', customCSSClass: 'half-width' },
                    { title: 'Océanie (hors Australie et Nouvelle-Zélande)', color: '#71ad49', customCSSClass: 'half-width' },
                    { title: 'Afrique subsaharienne', color: '#265e91', customCSSClass: 'half-width' },
                    { title: 'Asie de l’Ouest', color: '#9e480e', customCSSClass: 'half-width' }
                ]} note={<span>Source: FAO. 2022. Indicateurs. <i>In: Objectifs de développement durable.</i> Rome. Consulté le 24 juin 2022. www.fao.org/sustainable-development-goals/indicators/fr.</span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure74}
                />
                <br /><br />
                <br /><br />
            </ContainerChart>


            <Container>
                <b>Références:</b>
		    <p><b>Rahbek, C., Borregaard, M.K., Colwell, R.K., Dalsgaard, B., Holt, B.G., Morueta-Holme, N., Nogues-Bravo, D., Whittaker, R.J. & Fjeldså, J.</b> 2019. Humboldt’s enigma: what causes global patterns of mountain biodiversity? <i>Science</i>, 365 (6458): 1108–1113.</p>
                    <br /><br /><br /><br />
            </Container>

        </React.Fragment>
    )
}


export default Sdg15;
